import {
  formatPerformanceTableValue,
  performanceMetricDef,
  type PerformanceDataPoint,
  type PerformanceMetricId,
} from '@/utils/performanceChartMetrics';
import { formatPerformanceTooltipDate } from '@/utils/performanceChartAxisTicks';

export function PerformanceTableView({
  points,
  visibleMetricIds,
}: {
  points: PerformanceDataPoint[];
  visibleMetricIds: PerformanceMetricId[];
}) {
  const metrics = visibleMetricIds.map((id) => performanceMetricDef(id));

  if (points.length === 0) {
    return (
      <p className="py-6 text-sm text-foreground-subtle">No performance data for this period.</p>
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="min-w-full text-sm">
        <thead className="bg-page text-left text-xs font-medium uppercase tracking-wide text-foreground-muted">
          <tr>
            <th className="px-4 py-3">Date</th>
            {metrics.map((metric) => (
              <th key={metric.id} className="px-4 py-3 text-right">
                {metric.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {points.map((point) => (
            <tr key={point.date} className="border-t border-border">
              <td className="px-4 py-2.5 text-foreground">{formatPerformanceTooltipDate(point.date)}</td>
              {metrics.map((metric) => (
                <td key={metric.id} className="px-4 py-2.5 text-right tabular-nums">
                  {formatPerformanceTableValue(point[metric.id], metric.format)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
